import { useState } from "react";

export default function Sliderprice({ initialvalue, value1, value2, value3, onChange = undefined }) {
  const minLimit = 0;
  const maxLimit = value3 ? value3 * 2 : 10000;
  
  const [minVal, setMinVal] = useState(0);
  const [maxVal, setMaxVal] = useState(initialvalue || (value3 ? value3 : 8900));

  const handleMinChange = (e) => {
    const value = Math.min(Number(e.target.value), maxVal - (maxLimit * 0.05));
    setMinVal(Math.round(value));
    if (onChange) onChange({ min: value, max: maxVal });
  };

  const handleMaxChange = (e) => {
    const value = Math.max(Number(e.target.value), minVal + (maxLimit * 0.05));
    setMaxVal(Math.round(value));
    if (onChange) onChange({ min: minVal, max: value });
  };

  // Calculate percentages for the background track
  const minPercent = ((minVal - minLimit) / (maxLimit - minLimit)) * 100;
  const maxPercent = ((maxVal - minLimit) / (maxLimit - minLimit)) * 100;

  return (
    <div className="price-slider-container">
      <style>
        {`
        .price-slider-container {
          padding: 10px 0 20px 0;
          font-family: inherit;
        }
        .price-title {
          font-size: 14px;
          font-weight: 700;
          color: #282c3f;
          text-transform: uppercase;
          margin-bottom: 20px;
          letter-spacing: 0.5px;
          text-align: left;
        }
        .slider-track-container {
          position: relative;
          width: 100%;
          height: 4px;
          margin-bottom: 24px;
        }
        .slider-track {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          border-radius: 2px;
          background: #eaeaec;
          z-index: 1;
        }
        .slider-track-active {
          position: absolute;
          top: 0;
          bottom: 0;
          background: #43c8ca;
          z-index: 2;
        }
        .range-input {
          position: absolute;
          width: 100%;
          height: 4px;
          top: 0;
          left: 0;
          background: none;
          pointer-events: none;
          -webkit-appearance: none;
          appearance: none;
          margin: 0;
          z-index: 3;
        }
        
        /* Webkit Thumbs */
        .range-input::-webkit-slider-thumb {
          height: 12px;
          width: 12px;
          border-radius: 50%;
          border: 3px solid #43c8ca;
          background: #ffffff;
          cursor: pointer;
          pointer-events: auto;
          -webkit-appearance: none;
          box-shadow: 0 1px 3px rgba(0,0,0,0.15);
          transition: transform 0.1s ease;
        }
        .range-input::-webkit-slider-thumb:hover {
          transform: scale(1.1);
        }

        /* Firefox Thumbs */
        .range-input::-moz-range-thumb {
          height: 12px;
          width: 12px;
          border-radius: 50%;
          border: 3px solid #43c8ca;
          background: #ffffff;
          cursor: pointer;
          pointer-events: auto;
          box-shadow: 0 1px 3px rgba(0,0,0,0.15);
          transition: transform 0.1s ease;
        }
        .range-input::-moz-range-thumb:hover {
          transform: scale(1.1);
        }
        
        .price-range-label {
          font-size: 14px;
          font-weight: 700;
          color: #282c3f;
          margin-top: 14px;
          text-align: left;
        }
        `}
      </style>
      
      <div className="price-title">Price</div>
      
      <div className="slider-track-container">
        <div className="slider-track" />
        <div 
          className="slider-track-active" 
          style={{ 
            left: `${minPercent}%`, 
            right: `${100 - maxPercent}%` 
          }} 
        />
        <input
          type="range"
          min={minLimit}
          max={maxLimit}
          value={minVal}
          onChange={handleMinChange}
          className="range-input"
        />
        <input
          type="range"
          min={minLimit}
          max={maxLimit}
          value={maxVal}
          onChange={handleMaxChange}
          className="range-input"
        />
      </div>
      
      <div className="price-range-label">
        ₹{minVal.toLocaleString('en-IN')} - ₹{maxVal.toLocaleString('en-IN')}
      </div>
    </div>
  );
}